import React from 'react'
import { CowBoyIcon, Coverage, VaccinesIcon } from 'src/assets/svg'
import { MovimentationIcon, WeighingIcon } from 'src/assets/png'
import {
  Lots,
  // Users,
  // Vaccine,
  Pastures,
  Properties,
  Reports,
  // ANCP,
  Dashboard,
  Perfil,
  DeathsAndDiseases,
  PregnancyDiagnosis,
  Reproduction,
  RegisterCouple,
  CouplePlanning,
  RegisterCouplePlanning,
  Genotyping,
  Sales,
  Animal,
  CreateAnimal,
  BreedingList,
  BreedingListDetails
} from 'src/pages/Protected'
import { BirthRegistration } from 'src/pages/Protected/Reproduction/BirthRegistration'
import { Weighing } from 'src/pages/Protected/HerdManagement/Weighing'
import { UnderConstruction } from 'src/pages/UnderConstruction'
import { Movimentation } from 'src/pages/Protected/HerdManagement/Movimentation'
import { HealthControl } from 'src/pages/Protected/HerdManagement/HealthControl'
import { HerdManagement } from 'src/pages/Protected/HerdManagement'
import ROUTES from 'src/constants/routes'
import { PastureDetail } from 'src/pages/Protected/Pasture/PastureDetail'
import { BirthForm } from 'src/pages/Protected/BirthForm'

export enum UserType {
  ADMIN = 'ADMIN',
  COWBOY = 'PEAO', // peão
  MANAGER = 'DONO' // dono
}

export interface MenuPermission {
  name: string
  path: string
  isMenuSideBar?: boolean
  allowedFor: UserType[]
  icon?: React.ElementType | string
  children?: MenuPermission[]
  index?: boolean
  element?: React.ReactElement
}

// ============================================
// PERMISSÕES DE MENU
// ============================================

const ALL_USERS = [UserType.ADMIN, UserType.COWBOY, UserType.MANAGER]
const ADMIN_MANAGER = [UserType.ADMIN, UserType.MANAGER]
const ADMIN_ONLY = [UserType.ADMIN]

export const MENU_PERMISSIONS: MenuPermission[] = [
  // ============================================
  // MENU PRINCIPAL
  // ============================================
  {
    name: 'Dashboard',
    isMenuSideBar: true,
    path: ROUTES.DASHBOARD,
    allowedFor: ALL_USERS,
    element: <Dashboard />
  },
  // {
  //   name: 'Registros Pendentes',
  //   isMenuSideBar: true,
  //   path: ROUTES.ADMIN.RECORD_VALIDATION,
  //   allowedFor: ADMIN_MANAGER
  // },

  // ============================================
  // GESTÃO DE GADO
  // ============================================
  {
    name: 'Gado',
    isMenuSideBar: true,
    path: ROUTES.ANIMAL.ROOT,
    allowedFor: ALL_USERS,
    element: <Animal />
  },
  {
    name: 'Cadastrar Gado',
    isMenuSideBar: false,
    path: ROUTES.ANIMAL.NEW,
    allowedFor: ALL_USERS,
    element: <CreateAnimal />
  },
  {
    name: 'Mortes e Doenças',
    isMenuSideBar: true,
    path: ROUTES.DEATHS_AND_DISEASES,
    allowedFor: ALL_USERS,
    element: <DeathsAndDiseases />
  },

  // ============================================
  // PRODUÇÃO
  // ============================================
  {
    name: 'Reprodução',
    isMenuSideBar: true,
    path: ROUTES.REPRODUCTION.ROOT,
    allowedFor: ALL_USERS,
    icon: Coverage,
    element: <Reproduction />,
    children: [
      {
        name: 'Processo de Cobertura',
        isMenuSideBar: true,
        path: ROUTES.REPRODUCTION.COVERAGE_PROCESS.NEW,
        allowedFor: ALL_USERS,
        element: <RegisterCouple />
      },
      {
        name: 'Lista de Reprodução',
        isMenuSideBar: true,
        path: ROUTES.REPRODUCTION.PREGNANCY_LIST,
        allowedFor: ALL_USERS,
        element: <BreedingList />
      },
      {
        name: 'Diag. de gestação',
        isMenuSideBar: true,
        path: ROUTES.REPRODUCTION.PREGNANCY_DIAGNOSIS,
        allowedFor: ALL_USERS,
        element: <PregnancyDiagnosis />
      },
      {
        name: 'Cadastrar Nascimento',
        isMenuSideBar: true,
        path: ROUTES.REPRODUCTION.BIRTH_REGISTRATION,
        allowedFor: ALL_USERS,
        element: <BirthRegistration />
      }
    ]
  },
  {
    name: 'Processo de Cobertura Detalhes',
    path: ROUTES.REPRODUCTION.COVERAGE_PROCESS.DETAILS,
    allowedFor: ALL_USERS,
    element: <RegisterCouple />
  },
  {
    name: 'Processo de Cobertura Novo',
    path: ROUTES.REPRODUCTION.COVERAGE_PROCESS.NEW,
    allowedFor: ALL_USERS,
    element: <RegisterCouple />
  },
  {
    name: 'Lista de Reprodução',
    path: ROUTES.REPRODUCTION.PREGNANCY_LIST,
    allowedFor: ALL_USERS,
    element: <BreedingList />
  },
  {
    name: 'Lista de Reprodução Detalhes',
    path: ROUTES.REPRODUCTION.PREGNANCY_LIST_DETAILS,
    allowedFor: ALL_USERS,
    element: <BreedingListDetails />
  },
  {
    name: 'Cadastrar Nascimento',
    path: ROUTES.REPRODUCTION.BIRTH_REGISTRATION,
    allowedFor: ALL_USERS,
    element: <BirthRegistration />
  },

  // ============================================
  // PLANEJAMENTO
  // ============================================
  {
    name: 'Casal Planejado',
    isMenuSideBar: true,
    path: ROUTES.COUPLE_PLANNING.ROOT,
    allowedFor: ALL_USERS,
    element: <CouplePlanning />
  },
  {
    name: 'Casal Planejado Novo',
    path: ROUTES.COUPLE_PLANNING.NEW,
    allowedFor: ALL_USERS,
    element: <RegisterCouplePlanning />
  },
  {
    name: 'Casal Planejado Detalhes',
    path: ROUTES.COUPLE_PLANNING.DETAILS,
    allowedFor: ALL_USERS,
    element: <RegisterCouplePlanning />
  },

  // ============================================
  // GENÉTICA
  // ============================================
  {
    name: 'Genotipagem',
    isMenuSideBar: true,
    path: ROUTES.GENETICS.GENOTYPING,
    allowedFor: ADMIN_MANAGER,
    element: <Genotyping />
  },
  {
    name: 'Avaliação Genética',
    isMenuSideBar: true,
    path: ROUTES.GENETICS.EVALUATION,
    allowedFor: ADMIN_MANAGER,
    element: <UnderConstruction />
  },

  // ============================================
  // MANEJO DO REBANHO
  // ============================================
  {
    name: 'Manejo do Rebanho',
    isMenuSideBar: true,
    path: ROUTES.HERD_MANAGEMENT.ROOT,
    allowedFor: ALL_USERS,
    icon: CowBoyIcon,
    element: <HerdManagement />,
    children: [
      {
        name: 'Pesagem',
        isMenuSideBar: true,
        path: ROUTES.HERD_MANAGEMENT.WEIGHTING,
        allowedFor: ALL_USERS,
        icon: WeighingIcon,
        element: <Weighing />
      },
      {
        name: 'Movimentação',
        isMenuSideBar: true,
        path: ROUTES.HERD_MANAGEMENT.MOVIMENTATION,
        allowedFor: ALL_USERS,
        icon: MovimentationIcon,
        element: <Movimentation />
      },
      {
        name: 'Controle Sanitário',
        isMenuSideBar: true,
        icon: VaccinesIcon,
        path: ROUTES.HERD_MANAGEMENT.HEALTH_CONTROL,
        allowedFor: ALL_USERS,
        element: <HealthControl />
      }
    ]
  },
  // {
  //   name: 'Processo Mangueiro',
  //   isMenuSideBar: true,
  //   path: ROUTES.HOLE_PROCESS,
  //   allowedFor: ALL_USERS
  // },

  // ============================================
  // GESTÃO ADMINISTRATIVA
  // ============================================
  {
    name: 'Vendas',
    isMenuSideBar: true,
    path: ROUTES.ADMIN.SALES,
    allowedFor: ADMIN_MANAGER,
    element: <Sales />
  },
  {
    name: 'Propriedades',
    isMenuSideBar: true,
    path: ROUTES.ADMIN.PROPERTIES,
    allowedFor: ADMIN_MANAGER,
    element: <Properties />
  },
  {
    name: 'Usuários',
    isMenuSideBar: true,
    path: ROUTES.ADMIN.USERS,
    allowedFor: ADMIN_MANAGER,
    element: <UnderConstruction />
  },
  {
    name: 'Locais',
    isMenuSideBar: true,
    path: ROUTES.LOCATIONS.ROOT,
    allowedFor: ALL_USERS,
    element: <Pastures />
  },
  {
    name: 'Local Detalhes',
    isMenuSideBar: false,
    path: ROUTES.LOCATIONS.DETAILS,
    allowedFor: ALL_USERS,
    element: <PastureDetail />
  },
  {
    name: 'Lote',
    isMenuSideBar: true,
    path: ROUTES.ADMIN.LOTS,
    allowedFor: ALL_USERS,
    element: <Lots />
  },
  {
    name: 'Ficha de Nascimento',
    isMenuSideBar: true,
    path: ROUTES.BIRTH_FORM.ROOT,
    allowedFor: ALL_USERS,
    element: <BirthForm />
  },
  {
    name: 'Vacinas',
    isMenuSideBar: true,
    path: ROUTES.ADMIN.VACCINE,
    allowedFor: ADMIN_ONLY,
    element: <UnderConstruction />
  },
  {
    name: 'Relatórios',
    isMenuSideBar: true,
    path: ROUTES.ADMIN.REPORTS,
    allowedFor: ADMIN_MANAGER,
    element: <Reports />
  },
  // {
  //   name: 'ANCP',
  //   isMenuSideBar: true,
  //   path: ROUTES.ADMIN.ANCP,
  //   allowedFor: ADMIN_MANAGER
  // },

  // ============================================
  // ROTAS AUXILIARES
  // ============================================
  {
    name: 'Perfil',
    path: ROUTES.PROFILE,
    allowedFor: ALL_USERS,
    element: <Perfil />
  },
  {
    name: 'Confirmações',
    path: ROUTES.AUTH.CONFIRMATIONS,
    isMenuSideBar: false,
    allowedFor: ALL_USERS
  }
]

// Alias para uso como configuração de rotas
export const ROUTES_CONFIG = MENU_PERMISSIONS
export const hasPermission = (userType: UserType, path: string): boolean => {
  const permission = MENU_PERMISSIONS.find((p) => {
    if (p.children && p.children.length > 0) {
      const childPermission = p.children.find((child) => child.path === path)
      if (childPermission) {
        return true
      }
    }
    return p.path === path
  })
  return permission ? permission.allowedFor.includes(userType) : false
}

export const getMenuItemsForUser = (userType: UserType) => {
  return MENU_PERMISSIONS.filter((permission) => permission.allowedFor.includes(userType))
}
